import { get } from 'lodash';

const severityColor = value => get({
  None:	'grey',
  Low: 'darkkhaki',
  Medium: 'orange',
  High: 'coral',
  Critical:	'red'
}, value, 'grey')

export { severityColor }